import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_focused_clock',
  propName: 'focusedClock',
  defaultState: {
    focusedClock: null
  },
  handler(focusedClock) {
    return {
      focusedClock
    };
  },
  reduce(state, { focusedClock }) {
    return {
      focusedClock
    };
  }
});
